import { PromoEnginePreviewResponseDataAttributes } from '@/api'
import { PromoPayload } from '@/modules/promo-engine/types'

/**
 * Slice "base" dello state Pinia del promo-engine.
 */
export type BaseState = {
  test: string
  previewPromoEngine: PromoEnginePreviewResponseDataAttributes & {
    input: PromoPayload | null
  }
}

export const createBaseState = (): BaseState => ({
  test: '',
  previewPromoEngine: {
    input: null,
  },
})
